<!-- /批量导入  -->
<template>
  <div v-loading = 'isLoading'  :element-loading-text="msgLoad">
    <el-form :model="form" ref="form" :rules="rules" label-width="100px">
      <!--用户角色-->
      <el-form-item label="用户角色" prop="type_role">
        <el-select v-model="form.type_role" placeholder="请选择用户角色">
          <el-option
            v-for="item in region"
            :key="item.id"
            :value="item.id"
            :label="item.role_name"
          ></el-option>
        </el-select>
      </el-form-item>
      <!--机构/院校-->
      <el-form-item label="机构/院校" prop="organization_id" >
        <el-autocomplete
          disabled
          @blur="blur"
          class="inline-input"
          v-model="state1"
          :fetch-suggestions="querySearch"
          placeholder="请输入机构/院校"
          @select="handleSelect"
        ></el-autocomplete>
      </el-form-item>
      <!--            是否发送短信-->
      <el-form-item label="是否发送短信">

        <el-radio v-model="form.is_send" label="1" disabled>发送</el-radio>
        <el-radio v-model="form.is_send" label="2" disabled>不发送</el-radio>

      </el-form-item>
    </el-form>
    <el-table max-height="630" :data="dataIm" border style="width: 100%">
      <el-table-column
        align="center"
        prop="realname"
        label="用户名"
        min-width="120"
      >
      </el-table-column>
<!--      <el-table-column-->
<!--        align="center"-->
<!--        prop="account"-->
<!--        label="账号"-->
<!--        min-width="120"-->
<!--      >-->
<!--      </el-table-column>-->
      <el-table-column
        align="center"
        prop="password"
        label="密码"
        min-width="150"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="phone"
        label="手机号"
        min-width="150"
      >
      </el-table-column>

      <el-table-column align="center" prop="sex" label="性别" min-width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.sex === 1">男</span>
          <span v-else-if="scope.row.sex === 0">女</span>
          <span v-else>未知</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="student_no"
        label="学号"
        min-width="150"
      >
      </el-table-column>
    </el-table>
    <div>
      <ImportsCom
        :on-success="handleSuccess"
        :before-upload="beforeUpload"
        style="display: inline-block"
      ></ImportsCom>
      <p style="margin-top: 10px">
        <a
          href="./userMouldTea.xls"
          download="userMouldTea.xls"
          style="font-size: 14px; cursor: pointer"
          >下载批量导入模板</a
        >
      </p>
    </div>
    <div style="text-align: center">
      <el-button type="success" @click="save">提交</el-button>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="80%"
    >
      <p v-show="this.accounted.length > 0">
        手机号(<span style="color: red">{{ this.accounted.toString() }}</span
        >)已存在
      </p>
      <br />
      <p v-show="this.phoneed.length > 0">
        手机号(<span style="color: red">{{this.phoneed.toString()}}</span>)手机号码不合法
      </p><br />
<!--      <p v-show="this.phoneAccountEqually.length > 0">-->
<!--        账号(<span style="color: red">{{this.phoneAccountEqually.toString()}}</span>)与手机号码相同不合法-->
<!--      </p>-->
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisibleMsg"
      width="40%"
    >
      <p v-for="(item,index) in msg" :key="index">{{item.msg}}</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisibleMsg1"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  Submit,
  Remotesearch,
  UserEexist,
} from "../../assets/js/network/network";
import ImportsCom from "./ImportsCom";
export default {
  name: "Imports",
  components: { ImportsCom },
  props: {
    region: Array,
  },
  data() {
    return {
      msgLoad:'正在添加中,请耐心等待...',
      isLoading:false,
      selectedOrganizationName:"",
      rules:{
        type_role: [
        { required: true, message: '请选择用户角色', trigger: 'change' }
      ],
        organization_id: [
          { required: true, message: '请选择用户角色', trigger: 'change' }
        ]},
      msg:[],
      dialogVisibleMsg:false,
      dialogVisible: false,
      phoneed: [], //手机号不合法的账号
      accounted: [], //已经存在的账号
      phoneAccountEqually:[],//手机号和账号相同
      value_array: [],
      state1: "",
      form: {
        //用户角色
        type_role: "",
        //机构/院校
        organization_id: "",
        is_send:'2', //是否发送短信
      },
      dataed: [], //不合法去重集合
      dataIm: [],
    };
  },
  mounted() {
    this.userInfo =JSON.parse( localStorage.getItem('session'))
    if(this.userInfo){
      this.state1 = this.userInfo.organization_name
      this.form.organization_id = this.userInfo.organization_id
    }
  },
  methods: {
    beforeUpload(file) {
      //导入
      var a = file;
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (isLt1M) {
        return true;
      }
      this.$message({
        message: "请不要上传大于1m的文件!",
        type: "warning",
      });
      return false;
    },
    handleSuccess({ results, header }) {

      this.msgLoad = '正在分析数据中,请耐心等待...'
      this.isLoading = true
      //导入内容

      this.phoneAccountEqually = []
      this.value_array = [];
      this.accounted = [];
      this.phoneed = [];
      this.dataIm = [];
      this.dataed = [];
        // console.log("223", results);

      let isTrueArr = []
      let name = ['账号','手机号','密码','姓名','性别','学号']
      for(var key in results[0]){
        isTrueArr.push(key)
      }

      let isTrue = true
      isTrueArr.map((item,index)=>{
        if(name.indexOf(item) == -1){
           isTrue = false
        }
      })
      if(!isTrue){
        this.$message.error('请下载使用正确模板导入数据')
        this.isLoading = false
        return
      }

      var data = results.map((item) => {
        return {
          realname: item.姓名,
          // account: item.账号,
          password: item.密码,
          student_no: item.学号,
          sex: item.性别,
          phone: item.手机号,
        };
      });
      if(data.length == 0){
        this.$message.warning('暂无识别数据')
        this.isLoading = false
        return
      }
      let isMsg = {
        isTrue:false,
        isPhoen:false,
        isName:false,
        isPass:false,
      }
      data.map((item, index) => {
        if (!item.phone) {
          item.phone = "";
          data.splice(index, 1);
          isMsg.isTrue = true
          isMsg.isPhoen = true
          // this.$message.warning("手机号为必填项(无手机号已自动去除)");
        }
      });
      data.map((item, index) => {
        if (!item.realname) {
          item.realname = "";
          data.splice(index, 1);
          isMsg.isTrue = true
          isMsg.isName = true
          // this.$message.warning("姓名为必填项(无姓名已自动去除)");
        }
      });
      data.map((item, index) => {
        if (!item.password) {
          item.password = "";
          data.splice(index, 1);
          isMsg.isTrue = true
          isMsg.isPass = true
          // this.$message.warning("密码为必填项(无密码已自动去除)");
        }
      });
      // if(isMsg.isTrue){
      //   this.$message({
      //     dangerouslyUseHTMLString: true,
      //     type:'warning',
      //     message: '<p v-if="isMsg.isName">姓名为必填项(无姓名已自动去除)</p>'+
      //       '<p v-if=" isMsg.isPhoen">手机号为必填项(无手机号已自动去除)</p>'+
      //       '<p v-if=" isMsg.isPass">密码为必填项(无密码已自动去除)</p>'
      //   });
      // }
      if(isMsg.isTrue){
        this.$message({
          dangerouslyUseHTMLString: true,
          type:'warning',
          message: `<p>${isMsg.isName?'姓名为必填项(无姓名已自动去除)':''}</p>`+
            `<p>${isMsg.isPhoen?'手机号为必填项(无手机号已自动去除)':''}</p>`+
            `<p>${isMsg.isPass?'密码为必填项(无密码已自动去除)':''}</p>`
        });
      }
      data.map((item) => {
        this.value_array.push({
          account: item.phone,
        });
        if (!item.student_no) {
          item.student_no = "";
        }
        if (!item.phone) {
          item.phone = "";
        }
        if (!item.realname) {
          item.realname = "";
        }
        if (!item.password) {
          item.password = "";
        }
        // if (!item.account) {
        //   item.account = "";
        // }
        // console.log(333,item.password.toString())
        // item.password = this.$md5(item.password.toString());
        if (item.sex == "男") {
          item.sex = 1;
        } else if (item.sex == "女") {
          item.sex = 0;
        } else {
          item.sex = 2;
        }
      });
      // console.log(22, data);
      let a = {
        value_array: this.value_array,
      };
      this.$post(this.$api.accountExist,a).then((res) => {
        if (res.code == 0) {
          res.ret.map((item) => {
            if (item.is_exist == 1) {
              this.accounted.push(item.account);
            }
          });
          // console.log(data);
          data.map((item, index) => {
            if (!!item.phone) {
              if (!/^[1][3,4,5,7,8,9][0-9]{9}$/.test(item.phone)) {
                this.phoneed.push(item.phone);
              }
            }
            // if(item.account == item.phone){
            //   this.phoneAccountEqually.push(item.account)
            //   console.log(888,this.phoneAccountEqually)
            // }
            this.dataed = [...new Set(this.accounted.concat(this.phoneed))];
          });
          function subArr(a, b) {
            return a.filter(function (i) {
              return b.indexOf(i.phone) == -1;
            });
          }
          this.dataIm = subArr(data, this.dataed);

          // console.log(this.dataIm);
          if (this.accounted.length > 0 || this.phoneed.length > 0 || this.phoneAccountEqually.length > 0) {
            // this.$alert(
            //   `<p v-show="this.accounted.length > 0">账号(<span style="color:red;">${this.accounted}</span>)已存在</p><br><p v-show="this.phoneed.length > 0>账号(<span style="color:red;">${this.phoneed}</span>)手机号码不合法</p>`,
            //   `提示`,
            //   {
            //     confirmButtonText: "确定",
            //     dangerouslyUseHTMLString: true,
            //   }
            // );
            this.dialogVisible = true;
          }
        }
        this.isLoading = false
      });
    },

    //院校下拉搜索，模糊查询
    async querySearch(queryString, cb) {
      console.log(queryString);
      let data = {
        organization_name: queryString,
        paginate: 500,
      };
      await Remotesearch(data).then((res) => {
        // console.log(res.ret.data)
        this.restaurants = res.ret.data;
        this.restaurants.map((item) => {
          item.value = item.name;
        });
      });
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },

    createStateFilter(queryString) {
      return (state) => {
        return state.name.indexOf(queryString) != -1;
      };
    },
    blur() {
      setTimeout(() => {
        console.log("失去焦点");
        if (this.state1 == this.selectedOrganizationName) {
          this.form.organization_id = this.form.organization_id;
        } else {
          this.state1 = "";
          this.form.organization_id = "";
        }
      }, 100);
    },
    handleSelect(item) {
      console.log(item);
      this.form.organization_id = item.id;
      this.selectedOrganizationName = item.name
    },
    //提交
    save() {
      this.form.value_array = this.dataIm;
      this.$refs.form.validate((valid) => {
        if (valid) {
          if(this.form.value_array.length == 0){
            this.$message.error('合法导入数据为空')
            return
          }
          this.form.value_array.forEach(item=>{
            if(item.password){
              item.password = this.$md5(item.password.toString());
            }
          })
          this.msgLoad = '正在添加中,请耐心等待...'
          this.isLoading = true
          this.$post(this.$api.accountBatchimport,this.form).then((res) => {
            if (res.code == 0) {
              // this.$emit("saveSuccess", true);
              this.$message.success("添加成功");
              this.isLoading = false
              if(!!res.ret){
                 this.dialogVisibleMsg = true
                 this.msg = res.ret
              }
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
      // this.form.value_array = this.dataIm;

    },
    dialogVisibleMsg1(){
        this.$emit("saveSuccess", true);
    }
  },
};
</script>

<style>
</style>
